import _ from 'lodash'

export default ({
  reading: { value },
  modelReadingType: {
    unit: { symbol },
  },
}) => `${_.round(value, 1)} ${symbol}`
